import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICountryContentStatus, ICountryDataList } from "../interfaces/icountrycontentstatus";
import { CountryService } from "../services/country.service";

@Injectable()
export class CountryContentStatusResolver implements Resolve<ICountryDataList> {
    constructor(private countryService : CountryService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ICountryDataList> {
        return  this.countryService.getCountriesWithContentStatus();
    }
}
